import {Route, Routes} from 'react-router-dom'
import ReportTable from './components/ReportTable'
import ReportData from './components/ReportData'
import ChecklistReport from './ChecklistReport'
import ParkingReport from './ParkingReport'
import CoordinateReport from './components/CoordinateReport'
import GeoFencingReportPage from './components/GeoFencingReportPage'
import JourneyTimeReportPage from './components/JourneyTimeReportPage'
import ReportList from './components/ReportList'
import EditInterviewQuestionaire from '../Interview/components/EditInterviewQuestionaire'
import InterviewList from '../Interview/components/InterviewList'
import ResponseWrapper from './components/ResponseWrapper'
import {useAuth} from '../../modules/auth'

function Report() {
  const {currentUser} = useAuth()

  return (
    <div>
      <Routes>
        <Route path='/' element={<ReportList />} />
        <Route path='/projectList' element={<InterviewList showAddButton={false} />} />
        <Route path='/reportList' element={<ReportTable />} />
        <Route path='/reportList/:projectId' element={<ReportTable />} />

        <Route path='/checklist/*' element={<ChecklistReport />} />
        <Route path='/parking/*' element={<ParkingReport />} />
        <Route path='/geofencing/*' element={<GeoFencingReportPage />} />
        <Route path='/journey/*' element={<JourneyTimeReportPage />} />
        <Route path='/coordinate/*' element={<CoordinateReport />} />

        {/* only for interview response */}
        {currentUser?.profileType === 'admin' && (
          <Route path='/:id/edit/:answerId' element={<EditInterviewQuestionaire />} />
        )}
        <Route path='/:id/*' element={<ResponseWrapper />} />
      </Routes>
    </div>
  )
}

export default Report
